import { render, staticRenderFns } from "./AccountReceivables.vue?vue&type=template&id=d642cd92&scoped=true&"
import script from "./AccountReceivables.vue?vue&type=script&lang=ts&"
export * from "./AccountReceivables.vue?vue&type=script&lang=ts&"
import style0 from "./AccountReceivables.vue?vue&type=style&index=0&id=d642cd92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d642cd92",
  null
  
)

export default component.exports